import { render } from "./leyarticulos-template.vue?vue&type=template&id=bf807450"
import script from "./leyarticulos-template.vue?vue&type=script&lang=js"
export * from "./leyarticulos-template.vue?vue&type=script&lang=js"

import "./leyarticulos-template.vue?vue&type=style&index=0&id=bf807450&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__